import type { ContextoAcesso, ContextoAtivoRef } from '@/types/contextoAcesso/types';

/**
 * Para onde a pessoa vai ao entrar num contexto. Fonte única: o roteamento
 * pós-login e o switcher precisam concordar, senão trocar de contexto leva a
 * uma tela e o próximo login leva a outra.
 */
export const rotaDoContexto = (contexto: ContextoAcesso | ContextoAtivoRef): string => {
  switch (contexto.tipo) {
    case 'PARTE_ARBITRAL':
      return `/portal/arbitragem/${contexto.id}`;
    case 'PARTE_EXTRAJUDICIAL':
      return `/portal/notificacao/${contexto.id}`;
    default:
      return '/';
  }
};
